import React from 'react'
import {cx} from '@emotion/css'
import styled from '@emotion/styled'
import {SoldOutBodyMessage} from 'components/SearchUnavailability/SoldOut/SoldOutBodyMessage'
import {SoldOutBase} from 'components/Unavailability/SoldOut/SoldOutBase'

import {Button} from '@vio/atlas/Button'
import {cssTheme} from '@vio/atlas/themes'
import {linariaMq} from '@vio/atlas/utils/breakpoints'
import {FormattedMessageWrapper} from '@vio/core/src/localization/components/FormattedMessage'

const ChangeDatesButton = styled(Button)`
  margin-top: ${cssTheme.layout.spacing.s400};
  display: block;
  &.--margin-top {
    margin-top: ${cssTheme.layout.spacing.s700};
  }
  ${linariaMq.desktopXs} {
    margin-top: ${cssTheme.layout.spacing.s500};
  }
`

interface Props {
  handleChangeDatesClick?: (event: React.MouseEvent) => void
  hasCompactButton?: boolean
}

export const UnavailabilityWithChangeDates: React.FC<Props> = ({
  handleChangeDatesClick,
  hasCompactButton = false
}) => {
  return (
    <SoldOutBase
      headerSlot={
        <FormattedMessageWrapper
          id="unavailability.soldout"
          defaultMessage="Sold out on your dates"
        />
      }
      contentSlot={<SoldOutBodyMessage />}
      actionSlot={
        Boolean(handleChangeDatesClick) && (
          <ChangeDatesButton
            variant="tertiary"
            fullWidth
            className={cx(!hasCompactButton && '--margin-top')}
            onClick={handleChangeDatesClick}
          >
            <FormattedMessageWrapper
              id="changeDates"
              defaultMessage="Change dates"
            />
          </ChangeDatesButton>
        )
      }
    />
  )
}
